import { Component } from '@angular/core';

@Component({
    selector: 'app-tasks-report',
    templateUrl: './tasks-report.component.html',
    styleUrl: './tasks-report.component.css',
    standalone: false
})
export class TasksReportComponent {

}
